var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "1.549 15.344 359.578 330.429"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M359.568 327.246 191.511 21.818a12.502 12.502 0 0 0-21.904 0L1.549 327.246A12.502 12.502 0 0 0 12.5 345.773h336.117a12.5 12.5 0 0 0 10.951-18.527M180.559 68.773l136.913 252.999H43.646z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M164.894 143.085v90.351c0 8.65 7.014 15.665 15.665 15.665s15.665-7.015 15.665-15.665v-90.351c0-8.651-7.015-15.665-15.665-15.665-8.651 0-15.665 7.015-15.665 15.665M180.559 265.364c-9.097 0-16.5 7.399-16.5 16.5 0 9.098 7.403 16.5 16.5 16.5s16.5-7.402 16.5-16.5c0-9.1-7.404-16.5-16.5-16.5"
  })));
};
export default SvgWarning;